<template>
  <div id="contain-dialog" v-if="componentName">
    <component :is="componentName" :props="dataComponent"></component>
  </div>
</template>
<script setup>
import { useRouter, useRoute } from 'vue-router';
import { ModuleContext } from '@/stores/moduleConst';

import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { ModuleDialog } from '@/stores/moduleConst';
import { DIALOG } from '@/constants/index';

  const store = useStore();
  let componentName = computed(() =>
    SetUpComponent(store.state[ModuleDialog].type)
  );
  let dataComponent = computed(() => store.state[ModuleDialog].data);
  //function
  function SetUpComponent(commandName) {
    switch ( typeof(commandName)) {
      case 'string':
        return commandName;
      default:
        return null;
    }
  }

  function HanldeClickOusideDialog() {
    store.commit('dialog/HIDE_DIALOG');
  }

</script>
<style lang="scss">
#contain-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999999999999999999999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
